<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Contacto</template>
                    <template slot="en">Contact</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <div class="row">

                <div class="col-md-6 col-sm-6">
                    <div>
                        <p class="title-content title-content-tertiary title-content-small">
                            <text-lang :lang="lang">
                                <template slot="es">Dirección</template>
                                <template slot="en">Address</template>
                            </text-lang>
                        </p>
                        <p class="text text-secondary">Calle Pantin, Edif. Galerias Pantin, Piso 1, Ofic.4, Urb Eduardo Leal, Chacao, Caracas, 1060, Venezuela</p>
                    </div>
                    <div>
                        <p class="title-content title-content-tertiary title-content-small">
                            <text-lang :lang="lang">
                                <template slot="es">Teléfonos</template>
                                <template slot="en">Phones</template>
                            </text-lang>
                        </p>
                        <div class="text text-secondary">+58 (212) 263 7126</div>
                        <div class="text text-secondary">+58 (212) 263 1465 </div>
                        <p class="text text-secondary"><a href="#!">info@crecepymes.com</a></p>
                    </div>
                    <div>
                        <p class="title-content title-content-tertiary title-content-small">Email</p>
                        <div class="text text-secondary"><a href="#!">info@crecepymes.com</a></div>
                    </div>
                </div>

                <div class="col-md-6 col-sm-6">
                    <div v-if="false">
                        <p class="title-content title-content-tertiary title-content-small">Envíenos un mensaje directo</p>
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <input type="text" class="input" placeholder="Email *">
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <input type="text" class="input" placeholder="Subject">
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <textarea class="input" name="message" id="message" rows="4" placeholder="Message *"></textarea>
                            </div>
                        </div>
                        <a href="#!" class="button button-static" style="margin-top: 5px">Enviar</a>
                        <div class="social-network justify-content-center" style="margin: 40px 0px">
                            <div class="item"><icon-linkedin /></div>
                            <div class="item"><icon-facebook /></div>
                            <div class="item"><icon-twitter /></div>
                            <div class="item"><icon-link /></div>
                        </div>
                    </div>
                    <div v-else style="width: 100%;">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5548.149769022478!2d-66.85678773904083!3d10.490075709619827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a58550a4a6efb%3A0x62fe1a3f182b8caa!2sInversiones%20Crece%20Pymes%20CA!5e0!3m2!1ses-419!2sve!4v1587350743588!5m2!1ses-419!2sve" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    </div>
                </div>

            </div>
            <div v-if="false" style="width: 100%; margin-top: 20px">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5548.149769022478!2d-66.85678773904083!3d10.490075709619827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a58550a4a6efb%3A0x62fe1a3f182b8caa!2sInversiones%20Crece%20Pymes%20CA!5e0!3m2!1ses-419!2sve!4v1587350743588!5m2!1ses-419!2sve" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import IconFacebook from '@/components/Icons/Facebook.vue'
import IconLinkedin from '@/components/Icons/Linkedin.vue'
import IconTwitter from '@/components/Icons/Twitter.vue'
import IconLink from '@/components/Icons/Link.vue'
import TextLang from '@/components/TextLang.vue'

export default {
  name: 'Contact',
  props: ['lang'],
  components: {
    Parallax,
    IconFacebook,
    IconLinkedin,
    IconTwitter,
    IconLink,
    TextLang
  }
}
</script>
